import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

function AgeCell (props) {
  return (
    <div className='col-xs-12 col-sm-4 col-md-4'>
      <Link
        to={{pathname: `/patients/${props.patientId}/age`, search: '?id=' + props.age.start}}>
        <div className='thumbnail border-hover'>
          <h4 className='center hvr-bounce-in'>{props.age.designation}</h4>
        </div>
      </Link>
    </div>
  )
}

AgeCell.propTypes = {
  age: PropTypes.object.isRequired,
  patientId: PropTypes.string.isRequired
}

class AgeGrid extends React.Component {
  render () {
    return (
      <ul className='age-grid'>
        {
          this.props.ages.map(function (currentValue, index) {
            return (<AgeCell key={index} age={currentValue} patientId={this.props.patientId} />)
          }.bind(this))
        }
      </ul>
    )
  }
}

AgeGrid.propTypes = {
  ages: PropTypes.array.isRequired,
  patientId: PropTypes.string.isRequired
}

export default AgeGrid



// WEBPACK FOOTER //
// ./src/components/general/Home/AgeGrid/AgeGrid.js